import { render, staticRenderFns } from "./CartPageOrderCta.vue?vue&type=template&id=64198b9e"
import script from "./CartPageOrderCta.vue?vue&type=script&lang=js"
export * from "./CartPageOrderCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports